import * as fromProductsList from './products/state/product-list/list-state';
import * as fromProductsDetails from './products/state/product-details/details-state';
import * as fromRelatedProducts from './products/state/related-product/related-state';
import * as fromCart from './products/state/shopping-cart/cart-state';
import * as fromStore from './stores/state/store/stores-state';
import * as fromCategory from './categories/state/category/categories-state';
import * as fromStoreDetails from './stores/state/store-details/store-details-state';
import * as fromContacts from './checkout/state/contacts/contacts-state';
import * as fromPaymentsProfile from './checkout/state/payments-profile/payments-profile-state';
import * as fromCheckout from './checkout/state/checkout/checkout-state';
import * as fromAddress from './checkout/state/address-verification/address-verification-state';
import { ActionReducerMap } from '@ngrx/store';
import * as fromProductsListReducers from './products/state/product-list/list-reducers';
import * as fromProductDetailsReducers from './products/state/product-details/details-reducers';
import * as fromRelatedProductsReducers from './products/state/related-product/related-reducers';
import * as fromStoreReducers from './stores/state/store/stores-reducers';
import * as fromCategoryReducers from './categories/state/category/categories-reducers';
import * as fromOrder from './orders/state/order-list/order-list-state';
import * as fromOrdersReducers from './orders/state/order-list/order-list-reducers';
import * as fromStoreDetailsReducers from './stores/state/store-details/store-details-reducers';
import * as fromContactsReducers from './checkout/state/contacts/contacts-reducers';
import * as fromPaymentsProfileReducers from './checkout/state/payments-profile/payments-profile-reducers';
import * as fromCheckoutReducers from './checkout/state/checkout/checkout-reducers';
import * as fromAddressVerificationReducers from './checkout/state/address-verification/address-verification-reducers';
export const PRODUCT_FEATURE = {stateKey: 'products-feature'};
export const STORE_FEATURE_KEY = 'stores-feature';
export const CATEGORY_FEATURE_KEY = 'categories-feature';
export const ORDER_FEATURE_KEY = 'order-feature';
export const CHECKOUT_FEATURE_KEY = 'checkout_feature';

/*-----------------------App Features State----------------------------*/
export interface AppState {
  products_list: fromProductsList.State;
  product_details: fromProductsDetails.State;
  related_products: fromRelatedProducts.State;
  stores: fromStore.State;
  categories: fromCategory.State;
  orders: fromOrder.State;
  store_details: fromStoreDetails.State;
  //contacts: fromContacts.State;
  paymentsProfile: fromPaymentsProfile.State;
  checkout: fromCheckout.State;
  address_verification: fromAddress.State;
}
export const featuresReducers: ActionReducerMap<AppState> = {
  products_list: fromProductsListReducers.reducer,
  product_details: fromProductDetailsReducers.reducer,
  related_products:fromRelatedProductsReducers.reducer,
  stores: fromStoreReducers.reducer,
  categories: fromCategoryReducers.reducer,
  orders: fromOrdersReducers.reducer,
  store_details: fromStoreDetailsReducers.reducer,
  //contacts: fromContactsReducers.reducer,
  paymentsProfile: fromPaymentsProfileReducers.reducer,
  checkout: fromCheckoutReducers.reducer,
  address_verification: fromAddressVerificationReducers.reducer
};
/*-----------------------App Features State----------------------------*/

